export const OPEN_CONFIRMATION_DIALOG = 'OPEN_CONFIRMATION_DIALOG'
export const CLOSE_CONFIRMATION_DIALOG = 'CLOSE_CONFIRMATION_DIALOG'

export const showConfirmationDialog = (title, message, positiveAction, negativeAction) => {
    return { type: OPEN_CONFIRMATION_DIALOG, payload: { title, message, positiveAction, negativeAction }}
}

export const closeConfirmationDialog = () => {
  return { type: CLOSE_CONFIRMATION_DIALOG }
}



// WEBPACK FOOTER //
// ./src/actions/confirmationDialog.js